import { Eye, Heart, UserCheck, Calendar } from 'lucide-react';
import { CATEGORY_LABELS } from '../constants/categories';

export const AnalyticsCard = ({ title, value, icon: Icon, trend, color = 'primary' }) => {
  const colorClasses = {
    primary: 'text-primary bg-primary/10',
    success: 'text-green-600 bg-green-100 dark:bg-green-950',
    warning: 'text-yellow-600 bg-yellow-100 dark:bg-yellow-950',
    info: 'text-blue-600 bg-blue-100 dark:bg-blue-950'
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground font-medium">{title}</p>
        <div className={`p-2 rounded-lg ${colorClasses[color]}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
      <div className="space-y-1">
        <p className="text-3xl font-bold">{value.toLocaleString('pt-BR')}</p>
        {trend && (
          <p className={`text-xs ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
            {trend > 0 ? '+' : ''}{trend}% vs mês anterior
          </p>
        )}
      </div>
    </div>
  );
};

export const EventAnalyticsRow = ({ event, onClick }) => {
  const views = event.views || 0;
  const favorites = event.favoriteUsers?.length || 0;
  const going = event.attendeesCount || 0;

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'text-green-600 bg-green-100 dark:bg-green-950 dark:text-green-300';
      case 'pending':
        return 'text-yellow-600 bg-yellow-100 dark:bg-yellow-950 dark:text-yellow-300';
      case 'rejected':
        return 'text-red-600 bg-red-100 dark:bg-red-950 dark:text-red-300';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <div
      onClick={onClick}
      className="bg-card border border-border rounded-lg p-4 hover:border-primary/50 cursor-pointer transition-all"
      data-testid={`analytics-row-${event.id}`}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="font-semibold truncate">{event.title}</h3>
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(event.status)}`}>
              {event.status === 'approved' ? 'Aprovado' : event.status === 'pending' ? 'Pendente' : 'Rejeitado'}
            </span>
            {event.isHighlighted && (
              <span className="px-2 py-0.5 bg-yellow-100 dark:bg-yellow-950 text-yellow-700 dark:text-yellow-300 rounded-full text-xs font-medium">
                Destaque
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{CATEGORY_LABELS[event.category] ?? event.category} • {event.city}</p>
        </div>

        <div className="flex items-center gap-6">
          <div className="text-center">
            <div className="flex items-center gap-1 text-muted-foreground mb-1">
              <Eye className="w-4 h-4" />
            </div>
            <p className="text-xl font-bold">{views}</p>
            <p className="text-xs text-muted-foreground">Visualizações</p>
          </div>

          <div className="text-center">
            <div className="flex items-center gap-1 text-muted-foreground mb-1">
              <Heart className="w-4 h-4" />
            </div>
            <p className="text-xl font-bold">{favorites}</p>
            <p className="text-xs text-muted-foreground">Favoritos</p>
          </div>

          <div className="text-center">
            <div className="flex items-center gap-1 text-muted-foreground mb-1">
              <UserCheck className="w-4 h-4" />
            </div>
            <p className="text-xl font-bold">{going}</p>
            <p className="text-xs text-muted-foreground">Confirmados</p>
          </div>
        </div>
      </div>
    </div>
  );
};

